<template>
  <div>
    <div
      v-if="offerSections.pricingTable"
      v-html="offerSections.pricingTable"
    >
    </div>
    <div v-else>
      <b-card
        v-if="bookingTypes.length > 1"
        no-body
        class="m-0 p-0"
      >
        <b-tabs
          card
          v-model="currentTab"
        >
          <b-tab
            v-for="{ name, additionalCosts, title } in bookingTypes"
            :key="name"
            :id="name.toLowerCase()"
          >
            <template #title>
              <div class="mt-2 ml-1 mr-1 mb-2">{{ title }}</div>
            </template>
            <b-card-body style="margin:24px;">
              <div>
                <PricingTable
                  :title="title"
                  :name="name"
                  :additionalCosts="additionalCosts"
                  :options="options"
                  @dirty="$emit('dirty')"
                />
              </div>
            </b-card-body>
          </b-tab>
        </b-tabs>
        <div class="text-right pb-2 offertable-append" v-if="offer.hash !== '03de491dd32223'"><br><span v-html="$t('pricing.vatNotice')"></span><span
            v-if="hasDiscount"
          ><br>{{ $t('pricing.discountNotice') }}</span></div>
      </b-card>
      <b-card v-else>
        <div>
          <h4>{{ (offer && (offer.hash === '4575499581' || offer.hash === '4c4cf70917' || offer.hash === 'cac3b1174c')) ? $t('pricing.priceIndication') : $t('pricing.offer') }}</h4>
          <PricingTable
            :title="bookingType.title"
            :name="bookingType.name"
            :additionalCosts="bookingType.additionalCosts"
            :options="options"
            @dirty="$emit('dirty')"
          />
        </div>
        <div class="text-right offertable-append" v-if="offer.hash !== '03de491dd32223'"><br><span v-html="$t('pricing.vatNotice')"></span><span
            v-if="hasDiscount"
          ><br>{{ $t('pricing.discountNotice') }}</span></div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import PricingTable from "./PricingTable.vue";
import placeholder from "./placeholder";
import { classifyAdditionalCost } from "../../misc/CombitTextClassifier";

export default {
  name: "Offer",
  components: {
    PricingTable
  },
  props: {
    options: Object,
  },
  mixins: [placeholder],
  data() {
    return {
      currentTab: null,
      excludedCostTypes: {
        inhouse: ['catering', 'seminarRoom'],
        firmen: ['notebookRental', 'surcharge'],
        remote: ['travelCosts', 'catering', 'seminarRoom', 'surcharge'],
        offen: [],
        hybrid: [],
      },
    }
  },
  methods: {
    ...mapMutations(['offerSectionSet', 'setSelectedTab']),
    filterCondtions(name) {
      return this.offer.additionalCosts.filter(position => {
        const classification = classifyAdditionalCost(position.description);
        return !classification || !this.excludedCostTypes[name].includes(classification.key);
      })
    },
    typeByName(name) {
      if (!this.offer || !this.offer.additionalCosts) {
        return {
          title: this.placeholder,
          name: this.placeholder,
          additionalCosts: [],
        }
      }
      return {
        name: name.charAt(0).toUpperCase() + name.slice(1),
        title: this.$t(`pricing.bookingTypes.${name === 'firmen' ? 'company' : name}`),
        additionalCosts: this.filterCondtions(name),
      }
    }
  },
  computed: {
    ...mapGetters(['offer', 'offerSections', 'selectedTab', 'isOpenOffer', 'hasDiscount']),
    bookingTypes() {
      if (this.offer.isRemote && !this.offer.isClassroom) { //remote only
        return [this.typeByName(`remote`)]
      }
      let types = [];
      if (this.offer.offerType_id === 1) { //inhouse
        types.push(this.typeByName(`inhouse`))
      }
      if (this.offer.offerType_id === 2) { //firmen
        types.push(this.typeByName(`firmen`))
      }
      if (this.offer.offerType_id === 3) { //kombi 
        types.push(this.typeByName(`inhouse`))
        types.push(this.typeByName(`firmen`))
      }
      if (this.offer.offerType_id === 4) { //inhouse only

        if (this.offer.isRemote) {
          types.push(this.typeByName(`hybrid`));
        }
        else {
          types.push(this.typeByName(`offen`));
        }
      }
      if (this.offer.isRemote) { //remote
        types.push(this.typeByName(`remote`))
      }
      return types;
    },
    bookingType() {
      return this.bookingTypes[0];
    },
    isOpenSeminar() {
      return this.offerType && this.offerType.id === 4;
    },
  },
  watch: {
    currentTab: function (newVal) {
      if (this.bookingTypes && this.bookingTypes.length > 1)
        this.setSelectedTab(this.bookingTypes[newVal].name.toLowerCase());
    }
  }
};
</script>

<style>
.card-header {
  padding-bottom: 0px;
  /*background-color: #edf3fa;*/
  background-color: #d6dee7;
  border-radius: 0px;
}

.offer .price-table .card-header-tabs {
  padding-bottom: 0px;
  margin-bottom: 0px;
}

.offer .nav-tabs .nav-link {
  text-decoration: none;
  color: #495057;
  font-weight: 100;
  font-size: 1.1em;
}



.offer .nav-tabs .nav-link.active {
  color: rgb(4, 43, 96);
  background-color: transparent;
  border-bottom: 1px solid #F8F8F8;
  font-weight: 600;
}

.offer .nav-tabs .nav-link.active:hover {
  border-bottom: 1px solid #F8F8F8 !important;
}

.offer .nav-tabs .nav-item:hover .nav-link {
  border-bottom-color: #bbb;
}



.offer .nav-tabs .nav-link:hover {
  color: #212529;
  background-color: #edf3fa;
  border-bottom: 1px solid #bbb;
}
</style>
